export default __webpack_public_path__ + "static/media/header-exam-icon.82a26df6.svg";